import React from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Link,
  DialogActions,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import type { SkillLevel, SkillNode } from "../types";
import { firstGoogleLink } from "../utils/google";

export interface DrillLeaf {
  id: string;
  name: string;
  level?: SkillLevel;
  tips?: string[];
  drills?: { title: string; desc?: string; details?: string; link?: string }[];
}

const DIALOG_BG = "#050815"; // or whatever you’re using for the dark shell

export default function DrillsDialog({
    isSmall,
    isLandscape,
  open,
  onClose,
  leaf,
  reverseHierarchy,
  onPickRandomAgain,
}: {
    isSmall:boolean,
    isLandscape: boolean;
  open: boolean;
  onClose: () => void;
  leaf: DrillLeaf | null;
  reverseHierarchy: string; // "Parent ← Grandparent ← …"
  onPickRandomAgain?: () => void; // ⭐ NEW (optional)
}) {
  if (!leaf) return null;
  const drills = (leaf as any).drills as DrillLeaf["drills"] | undefined;

  // console.error({ drills });

  const tips = leaf.tips || [];

  // console.error({ drills, tips });

  const title = `${leaf.name}  |  ${reverseHierarchy}${
    reverseHierarchy ? "  |  " : ""
  }${leaf.level ?? ""}`;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: { bgcolor: DIALOG_BG, color: "#e5ecff", fontSize: isSmall ? 12: 16 },
      }}
      sx={{ zIndex: "9900000 !important", fontSize: isSmall ? 12: 16  }}
    >
      <DialogTitle
        sx={{
          bgcolor: "#0b1020",
          color: "#e5ecff",
          //bgcolor: DIALOG_BG,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box sx={{ fontWeight: 700 }}>{title}</Box>
        <IconButton onClick={onClose} sx={{ ml: "auto" }}>
          <CloseIcon sx={{ color: "#9fb3ff" }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ bgcolor: "#0b1020", color: "#e5ecff" }}>
        {tips.length > 0 ? (
          <>
            {/* <Box sx={{ fontWeight: 700, mb: 1 }}>
                Quick drills
              </Box> */}
            <List dense>
              {tips.map((t, i) => (
                <ListItem key={i}>
                  <ListItemText
                    primary={t}
                    primaryTypographyProps={{ sx: { fontSize:isSmall ? 12:  "16px", color: "#e5ecff" } }}
                  />
                </ListItem>
              ))}
            </List>
          </>
        ) : null}
        {drills && drills.length ? (
          <List dense >
            {drills.map((d, i) => (
              <ListItem  key={i} alignItems="flex-start">
                <ListItemText 
                  primary={d.title}
                  secondary={
                    <>
                      {d.desc ? (
                        <Box>
                          {/* <Box sx={{ color: "#bfcfff" }}>{"details: " + d.details}</Box> */}
                          <Box sx={{ color: "#bfcfff" }}>{d.desc}</Box>
                          {/* {d.desc ? <Box>{d.desc}</Box> : null} */}
                        </Box>
                      ) : (
                        "nothing"
                      )}
                      {d.link ? (
                        <Box sx={{ mt: 0.5 }}>
                          <Link href={d.link} target="_blank" underline="hover">
                            Find a demo
                          </Link>
                        </Box>
                      ) : null}
                    </>
                  }
                  primaryTypographyProps={{
                    sx: { color: "#e5ecff", fontWeight: 600 },
                  }}
                   secondaryTypographyProps={{ component: "div" }}
                >
                  {"foo"}
                </ListItemText>
              </ListItem>
            ))}
          </List>
        ) : null}

        {/* Always offer a generic search for more */}
        <Box sx={{ mt: 2 }}>
          <Link
            href={firstGoogleLink(leaf as unknown as SkillNode)}
            target="_blank"
            underline="hover"
            sx={{ textDecoration: "underline" }}
          >
            Find drills on Google
          </Link>
        </Box>
      </DialogContent>
      {onPickRandomAgain ? (
        <DialogActions
          sx={{ textAlign: "center !important", justifyContent: "left" }}
        >
          {/* Only show this if a callback was passed in */}
          {onPickRandomAgain && (
            <Button
              onClick={() => {
                // close this dialog, then let the parent spin again
                onClose();
                onPickRandomAgain();
              }}
              variant="outlined"
              color="primary"
              sx={{ textAlign: "center !important", marginLeft: "14px" }}
            >
              Pick Random Again
            </Button>
          )}

          {/* <Button onClick={onClose} color="inherit">
          Close
        </Button> */}
        </DialogActions>
      ) : null}
    </Dialog>
  );
}
